module.exports = __webpack_public_path__ + "46ab537aba1d9109bd64cf9641e26f43.svg";